module.exports = __webpack_public_path__ + "img/icon_heart_3.da9c3a2c.svg";